export default "__VITE_ASSET__DoUojzzd__"